// src/components/RequireModule.jsx
//
// Гейтит роут по модулю: редирект на главную, если модуль выключен в магазине
// ИЛИ у сотрудника нет права на него (canSeeModule — единый источник правды).
// Пока shop не загружен — пропускаем (страница сама покажет лоадер).

import { Navigate } from 'react-router-dom';
import { useMyShop } from '../hooks/useMyShop';
import { useAuth } from '../hooks/useAuth';
import { canSeeModule } from '../config/modules';

export default function RequireModule({ module, children }) {
  const shop = useMyShop();
  const { isOwner, can } = useAuth();
  // shop ещё не загружен — не редиректим раньше времени
  if (shop && !canSeeModule(shop, module, { isOwner, can })) {
    return <Navigate to="/" replace />;
  }
  return children;
}
